/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../elements/grid-form-row/css/grid-form-row';
import '../elements/grid-form-cell/css/grid-form-cell';
import './grid-form.scss';
